// A "platform (super) admin" — allowed to see cross-tenant tools like the
// Platform Console. This is stricter than isAdmin: only internal CrediArc staff
// (an @crediarc.com email) with admin rights qualify, so a tenant-level admin
// can never reach cross-tenant management even if they carry isAdmin.
export const isPlatformAdmin = (email, isAdmin) =>
  !!isAdmin && /@crediarc\.com$/i.test(String(email || "").trim());
